export const defaultImagePaths = {
    CURRENCY_LOGO: 'assets/missions/generic-coin.svg',
};

export const DEFAULT_SIDEBAR_GUILDS_COUNT = 10;

export const VERIFY_GUILD_LINK = 'https://forms.gle/ebTUxga3w93QFn8v8';
export const TELEGRAM_GENERAL_LINK = 'https://t.me/bitd3gree';
export const BINANCE_JOIN_LINK = 'https://www.bitdegree.org/crypto/goon/binance';
export const BYDFI_JOIN_LINK = 'https://www.bitdegree.org/crypto/goon/bydfi';
export const COINBASE_JOIN_LINK = 'https://www.bitdegree.org/crypto/goon/coinbase';
export const OGVIO_LINK = 'https://www.bitdegree.org/crypto/goon/ogvio-missions';
